import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatDate, LOCALE_MAP } from 'utils/locale-formatting'
import { Card } from 'Components/ui'
import { StatusChip } from 'Components/common/StatusChip'
import styled from 'styled-components'

const STATUS_KEY = {
  'Published': 'published',
  'Draft': 'draft',
  'Under Review': 'review',
  'Approved': 'approved',
  'Archived': 'archived',
}

const SvgIcon = styled.svg`
  width: 20px;
  height: 20px;
  display: block;
  color: var(--vo-info);
`

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

const IconWrapper = styled.div`
  margin-top: 4px;
  line-height: 0;
  flex-shrink: 0;
`

const Details = styled.div`
  flex: 1;
  min-width: 0;
`

const Name = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: var(--vo-ink);
`

const MetaRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
  align-items: center;
`

const MetaText = styled.span`
  font-size: 12px;
  color: var(--vo-slate);
`

const LastUpdated = styled.div`
  font-size: 12px;
  color: var(--vo-slate);
  margin-top: 8px;
`

export const PolicyCard = ({
  name,
  version,
  status,
  visibility,
  lastUpdated,
  onClick,
}) => {
  const { t, i18n } = useTranslation('transparency')
  const locale = LOCALE_MAP[i18n.language] ?? 'en-US'
  const validVisibilities = ['public', 'protected', 'private']
  const visKey = validVisibilities.includes(visibility) ? visibility : 'private'
  const visLabel = t(`shared.policy.visibility.${visKey}`)
  const statusKey = STATUS_KEY[status] || 'draft'
  const statusLabel = t(`shared.policy.status.${statusKey}`)

  return (
    <Card onClick={onClick}>
      <Content>
        <IconWrapper>
          <SvgIcon viewBox="0 0 24 24" fill="currentColor">
            <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-3.06 16L7.4 14.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L10.94 18zM13 9V3.5L18.5 9H13z" />
          </SvgIcon>
        </IconWrapper>
        <Details>
          <Name>{name}</Name>
          <MetaRow>
            <StatusChip label={visLabel} variant={visKey} />
            <MetaText>{t('shared.policy.version', { version })}</MetaText>
            <MetaText>{statusLabel}</MetaText>
          </MetaRow>
          {lastUpdated && (
            <LastUpdated>
              {t('shared.policy.lastUpdated', { date: formatDate(lastUpdated, locale) })}
            </LastUpdated>
          )}
        </Details>
      </Content>
    </Card>
  )
}
